import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false, pharmacistOnly = false }) {
  const { user, checked } = useAuth();
  if (!checked || user === null) {
    return <div className="grid place-items-center h-screen text-muted-foreground">Chargement…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (pharmacistOnly && user.role !== "pharmacien" && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
